<mat-toolbar class="image-move-toolbar mat-elevation-z3" color="accent" *ngIf="count > 0">

    <button mat-icon-button (click)="clear.emit()" matTooltip="Clear Selection">
        <mat-icon>clear</mat-icon>
    </button>

    <span class="flex-spacer" aria-live="polite">
        {{ count }} Image{{ count === 1 ? '' : 's' }} Selected
    </span>

    <button mat-flat-button (click)="move.emit()">
        <mat-icon>arrow_forward</mat-icon>
        <span>Move</span>
    </button>

</mat-toolbar>
